module.exports = __webpack_public_path__ + "static/media/UniNeueBook-Italic.d5bb4d4b.eot";